import { useMemo } from 'react'
import { useWagmi } from 'libs/wagmi'
import {
  getBep20Bytes32Contract,
  getBep20Contract,
  getBoostingServiceContract,
  getLpTokenContract,
  getMulticallContract,
  getStakingServiceContract,
  getWethContract,
} from 'utils/contractHelpers'

/**
 * Helper hooks to get specific contracts (by ABI)
 */

export const useBep20 = (address: string) => {
  const { signer } = useWagmi()

  return useMemo(() => (address ? getBep20Contract(address, signer) : null), [address, signer])
}

export const useBytes32TokenContract = (address: string) => {
  const { signer } = useWagmi()

  return useMemo(() => (address ? getBep20Bytes32Contract(address, signer) : null), [address, signer])
}

export const useStakingService = (address: string) => {
  const { chainId, signer } = useWagmi()

  return useMemo(() => getStakingServiceContract(address, chainId, signer), [address, chainId, signer])
}

export const useBoostingPoolService = (address: string) => {
  const { signer } = useWagmi()

  return useMemo(() => getBoostingServiceContract(address, signer), [address, signer])
}

export const useWethContract = () => {
  const { chainId, signer } = useWagmi()

  return useMemo(() => getWethContract(chainId, signer), [chainId, signer])
}

export const usePairContract = (address: string) => {
  const { signer } = useWagmi()

  return useMemo(() => (address ? getLpTokenContract(address, signer) : null), [address, signer])
}

export const useMulticallContract = () => {
  const { chainId, signer } = useWagmi()

  return useMemo(() => getMulticallContract(chainId, signer), [chainId, signer])
}
